import Crud from "../Crud";
import { brown } from "@mui/material/colors";

/**
 * Static helper functions related to Accounts.
 */
export default class Permission extends Crud {
  /**
   * @param {object} permission The permission object.
   * @returns The display name of the permission.
   */
  static getDisplayName(permission) {
    return permission.name;
  }

  /**
   * Determines if a permission matches a search query.
   *
   * @param {object} permission The permission to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the permission matches the query.
   */
  static match(permission, query) {
    return (
      (permission.name !== null &&
        permission.name.toLowerCase().includes(query)) ||
      permission.id === +query
    );
  }

  /**
   * @param {array} permissions The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(permissions) {
    return permissions.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return brown;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Article";
  }
}
